import makeStyles from '@mui/styles/makeStyles'
import { getBuildHeight } from '../../../build/utils/get-build-height'

export const useStyles = makeStyles(({ palette }) => ({
  sectionItem: {
    width: '100%',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      cursor: 'pointer',
      '& $editSectionButton, $deleteSectionButton': {
        display: 'block'
      }
    }
  },
  accordion: {
    boxShadow: 'none',
    '&:before': { display: 'none' },
    borderRadius: '10px !important',
    marginBottom: '8px'
  },
  sessionItem: {
    width: '100%',
    '&.selected': {
      '&:hover': {
        '& $editSessionButton, $deleteSessionButton': {
          display: 'block'
        }
      }
    }
  },
  sessionListContainer: {
    overflowY: 'auto',
    maxHeight: getBuildHeight({ extraPxToAdd: 70 }),
    margin: 0,
    padding: 0,
    /* Firefox */
    scrollbarWidth: 'thin',
    scrollbarColor: '#A6A6A6 #EBEBEB',
    scrollBehavior: 'smooth',
    scrollPaddingRight: '4px',
    paddingRight: '4px',
    listStyle: 'none',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '2px',
      marginLeft: '2px'
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
      backgroundColor: '#EBEBEB'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      backgroundColor: '#A6A6A6'
    }
  },
  pageItem: {
    '&:hover': {
      backgroundColor: palette.background.selected,
      cursor: 'pointer'
    }
  }
}))
